
import { Language } from './types';

export const translations: Record<Language, any> = {
  en: {
    welcome: "Welcome to Hum Hena",
    hire_expert: "Hire Expert",
    i_need_work: "I need work done",
    i_am_expert: "I am Expert",
    i_want_to_earn: "I want to earn",
    get_started: "Get Started Now",
    select_language: "Select Language",
    continue: "Continue",
    settings: "Settings",
    dashboard: "Dashboard",
    tasks: "Tasks",
    identity: "Profile",
    home: "Home",
    my_kaam: "My Activities",
    language: "Language",
    change_language: "Change App Language",
    logout: "Log Out",
    wallet: "Wallet",
    history: "History",
    preferences: "Preferences",
    privacy: "Privacy & Security",
    help: "Help Center",
    terms: "Terms of Service",
    edit_profile: "Edit Profile",
    your_feedback: "Your Feedback",
    media_attached: "Multimedia Feedback",
    rate_experience: "Rate Your Experience",
    // New Keys
    active: "Active",
    completed: "Completed",
    cancelled: "Cancelled",
    no_jobs: "No jobs found",
    search_placeholder: "Search services ('leaking tap')..",
    nearby_pros: "Nearby Worker",
    post_kaam: "Post Request",
    book_now: "Book",
    track_location: "Track Live Location",
    earnings: "Total Earnings",
    withdraw: "Withdraw",
    portfolio: "Portfolio",
    verification: "Verification",
    online: "Online",
    offline: "Offline",
    overview: "Overview",
    verify_id: "Verify Profile",
    stats: "Revenue Analytics",
    requests: "Requests",
    my_tasks: "My Tasks",
    accept_job: "Accept This Job",
    start_task: "Start Task",
    finish_task: "Request Finish OTP",
    call: "Call",
    chat: "Chat",
    track: "Track",
    Plumber: "Plumber",
    Electrician: "Electrician",
    Carpenter: "Carpenter",
    Mason: "Mason",
    Painter: "Painter",
    Cleaner: "Cleaner",
    Mechanic: "Mechanic",
    Gardener: "Gardener"
  },
  hi: {
    welcome: "Hum Hena में आपका स्वागत है",
    hire_expert: "विशेषज्ञ चुनें",
    i_need_work: "मुझे काम करवाना है",
    i_am_expert: "मैं विशेषज्ञ हूँ",
    i_want_to_earn: "मैं कमाना चाहता हूँ",
    get_started: "अभी शुरू करें",
    select_language: "भाषा चुनें",
    continue: "जारी रखें",
    settings: "सेटिंग्स",
    dashboard: "डैशबोर्ड",
    tasks: "कार्य",
    identity: "प्रोफ़ाइल",
    home: "होम",
    my_kaam: "मेरी गतिविधियाँ",
    language: "भाषा",
    change_language: "ऐप की भाषा बदलें",
    logout: "लॉग आउट",
    wallet: "वॉलेट",
    history: "इतिहास",
    preferences: "प्राथमिकताएं",
    privacy: "गोपनीयता और सुरक्षा",
    help: "सहायता केंद्र",
    terms: "सेवा की शर्तें",
    edit_profile: "प्रोफ़ाइल बदलें",
    your_feedback: "आपकी प्रतिक्रिया",
    media_attached: "मल्टीमीडिया फीडबैक",
    rate_experience: "अपने अनुभव को रेट करें",
    // New Keys
    active: "सक्रिय",
    completed: "पूरा हुआ",
    cancelled: "रद्द",
    no_jobs: "कोई काम नहीं मिला",
    search_placeholder: "सेवाएं खोजें (जैसे 'नल टपकना')...",
    nearby_pros: "आस-पास के विशेषज्ञ",
    post_kaam: "अनुरोध भेजें",
    book_now: "बुक करें",
    track_location: "लाइव लोकेशन ट्रैक करें",
    earnings: "कुल कमाई",
    withdraw: "पैसे निकालें",
    portfolio: "पोर्टफोलियो",
    verification: "सत्यापन",
    online: "ऑनलाइन",
    offline: "ऑफलाइन",
    overview: "विवरण",
    verify_id: "पहचान सत्यापित करें",
    stats: "कमाई का विश्लेषण",
    requests: "अनुरोध",
    my_tasks: "मेरे कार्य",
    accept_job: "यह कार्य स्वीकार करें",
    start_task: "काम शुरू करें",
    finish_task: "ओटीपी मांगें",
    call: "कॉल",
    chat: "चैट",
    track: "ट्रैक",
    Plumber: "प्लंबर",
    Electrician: "इलेक्ट्रीशियन",
    Carpenter: "बढ़ई",
    Mason: "मिस्त्री",
    Painter: "पेंटर",
    Cleaner: "क्लीनर",
    Mechanic: "मैकेनिक",
    Gardener: "माली"
  }
};

export const useTranslation = (lang: Language) => {
  return translations[lang] || translations.en;
};
